// Der Knopf "…" eines Menues "Weitere Aktionen" (Experience-Review KONTAKT, P2):
// ueberall mit demselben Tooltip, damit das Zeichen nicht geraten werden muss.
//
// Fluent-Muster MenuTrigger > Tooltip > Button: MenuTrigger reicht Ereignisse
// und Ref an dieses Element, es reicht sie an den Knopf weiter (forwardRef).
//
// ZWEI ARTEN, DEN NAMEN ZU TRAGEN:
// - ohne `bezug` ist der Tooltip der Name (relationship="label"), ein
//   aria-label entfaellt -- sonst hiesse der Knopf doppelt;
// - mit `bezug` (Zeilenknopf, "Aktionen für Maria Beispiel") bleibt der Name
//   mit Bezug, und der Tooltip zeigt nur den kurzen Text (relationship=
//   "description"), wie bei jedem Zeilenknopf der Anwendung.

import { forwardRef, type ReactElement } from 'react';
import { Button, Tooltip, type ButtonProps } from '@fluentui/react-components';

export const WEITERE_AKTIONEN = 'Weitere Aktionen';

export type MehrKnopfProps = Omit<ButtonProps, 'aria-label' | 'children'> & {
  /** Der volle Name eines Zeilenknopfs; ohne ihn heisst der Knopf "Weitere Aktionen". */
  readonly bezug?: string | undefined;
};

export const MehrKnopf = forwardRef<HTMLButtonElement, MehrKnopfProps>(function MehrKnopf({ bezug, ...knopf }, weiter): ReactElement {
  // ButtonProps erlaubt auch `as="a"`; Ref und Handler sind darum als Vereinigung
  // beider Elemente typisiert und lassen sich nicht unveraendert weiterreichen.
  // Dieser Knopf ist immer ein <button>.
  const ref = weiter as never;
  const eigenschaften = knopf as ButtonProps;
  if (bezug === undefined) {
    return (
      <Tooltip content={WEITERE_AKTIONEN} relationship="label" withArrow>
        <Button ref={ref} {...eigenschaften} />
      </Tooltip>
    );
  }
  return (
    <Tooltip content={WEITERE_AKTIONEN} relationship="description" withArrow>
      <Button ref={ref} {...eigenschaften} aria-label={bezug} />
    </Tooltip>
  );
});
